import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }


import PInputSwitch from "primevue/inputswitch";

export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {




const input = (value: boolean) => {
  emits("update:modelValue", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PInputSwitch), {
      "model-value": __props.modelValue,
      onInput: input
    }, null, 8, ["model-value"]),
    _createElementVNode("span", {
      class: _normalizeClass(["text-sm", { italic: __props.modelValue }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})